import { HttpInterceptor, HttpHandler, HttpEvent, HttpRequest, HttpErrorResponse } from '@angular/common/http'
import { Observable, EMPTY, of, throwError } from 'rxjs'
import { AuthManager } from './AuthManager'
import { Router } from '@angular/router'
import { tap, catchError } from 'rxjs/operators'
import { Injectable } from '@angular/core'

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
   constructor(private authMgr: AuthManager, private router: Router) {}

   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      // if we want to preemptively check the token, we need some way to allow anon requests
      // skip for now, the server will just 401 us anyway

      const token = this.authMgr.getToken()
      let useReq = req
      if (token && !req.url.includes('graph.microsoft.com')) {
         useReq = req.clone({
            headers: req.headers.set('Authorization', `Bearer ${token}`),
         })
      }

      // handle 401 in responses
      return next.handle(useReq).pipe(
         catchError((err) => {
            if (err instanceof HttpErrorResponse) {
               if (err.status === 401) {
                  this.authMgr.clearAndRedirect()
               } else if (err.status === 403) {
                  // Keep users in-app for authorization failures; do not force logout.
                  console.warn('Authorization denied for request', {
                     route: this.router.url,
                     requestUrl: req.url,
                     status: err.status,
                  })
               }
            }
            return throwError(err)
         }),
      )
   }
}
